import { useAuth0 } from '@auth0/auth0-react'
import { RouteProps } from 'react-router-dom'

import AuthLoading from '@view/Auth/Loading'
export const ProtectedRoute = ({ children }: RouteProps) => {
  const { isLoading, isAuthenticated } = useAuth0()

  return <>{isLoading ? <AuthLoading /> : isAuthenticated && children}</>
}
